export enum OrderStatus {
  UNKNOWN = 0,
  SAVED,
  PAID,
  CANCELLED,
}
